export const LongitudinalClassId = Object.freeze({HISTORY: "history", SCORED_FORM: "scoredForm", MULTI_AREA_PROFILE: "multiAreaProfile"})
export const LongitudinalRendererId = Object.freeze({HISTORY: "history", SCORED_FORM: "scoredForm", MULTI_AREA_PROFILE: "multiAreaProfile"})
